/**
 * Builder-modal icon set.
 *
 * These replace the Unicode glyphs the modal used to lean on (✕ ⋯ ▾ ＋ ✓).
 * Glyphs inherit a text font's metrics and weight, so they never optically
 * match each other or the rest of the UI — these are drawn on one grid
 * (24px box, 2px round stroke, currentColor) so every control in the modal
 * carries the same line weight.
 */
import React from "react";

const base = (size, extra) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
  ...extra,
});

export const IconClose = ({ size = 15 }) => (
  <svg {...base(size)}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const IconMore = ({ size = 17 }) => (
  <svg {...base(size, { strokeWidth: 2.4 })}>
    <circle cx="5" cy="12" r="0.6" />
    <circle cx="12" cy="12" r="0.6" />
    <circle cx="19" cy="12" r="0.6" />
  </svg>
);

export const IconChevron = ({ size = 15 }) => (
  <svg {...base(size, { strokeWidth: 2.2 })}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const IconPlus = ({ size = 14 }) => (
  <svg {...base(size, { strokeWidth: 2.2 })}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconCheck = ({ size = 14 }) => (
  <svg {...base(size, { strokeWidth: 2.6 })}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const IconBolt = ({ size = 19 }) => (
  <svg {...base(size)}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

/* Empty setup panel — "pick a card on the left". */
export const IconPointer = ({ size = 30 }) => (
  <svg {...base(size, { strokeWidth: 1.6 })}>
    <path d="M3 3l7.5 18 2.5-7.5L20.5 11z" />
  </svg>
);
